"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var appointmentDetailsStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette;
    return ({
        appointmentDetailsWrapper: {
            borderTop: "1px solid " + palette.primaryDisabled.main,
            padding: '20px 0',
        },
        title: {
            paddingBottom: '20px',
        },
        element: {
            padding: '2px 0',
        },
        comments: {},
    });
});
exports.default = appointmentDetailsStyles;
